import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { applicationTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseRemoveTerminalSolutionForApplicationMutationProps = {
	applicationId: string | undefined;
	onSuccess?: Function;
	onError?: Function;
};

type RemoveTerminalMutationProps = {
	terminalId: string;
};

const useRemoveTerminalSolutionForApplicationMutation = ({
	applicationId,
	onSuccess,
	onError,
}: UseRemoveTerminalSolutionForApplicationMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		({ terminalId }: RemoveTerminalMutationProps) => {
			return applicationTerminalService.removeTerminalSolution(
				terminalId,
				applicationId,
			);
		},
		{
			onSuccess(result) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Terminal has been removed successfully",
					}),
				);
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useRemoveTerminalSolutionForApplicationMutation;
